































import _ from 'lodash'
import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import BasePage from '@/tcw/components/BasePage'
import * as ApiPath from '@/tcw/constant/ApiPath'
import KoutsuhiCard from '../molecules/KoutsuhiCard.vue'
import { ApiGeneralObjectArrayPayload } from '@/tcw/api/types'
import Getsudo from '@/tcw/domain/Getsudo'
import { ArrayDataGetComponent } from '@/tcw/components/DataGetComponent'
import KintaiLocalHeader from '@/components/kintai/molecules/KintaiLocalHeader.vue'

@Component({
  components: { TcwLayoutBasicTemplate, KoutsuhiCard, KintaiLocalHeader }
})
export default class KoutsuhiListPage extends Mixins(BasePage, ArrayDataGetComponent) {
  protected koutsuhiList: ApiGeneralObjectArrayPayload = []

  get apiPath(): string {
    return ApiPath.buildPath(ApiPath.Paths.KoutsuhiList.get, {
      year: this.currentGetsudo.yearValue,
      month: this.currentGetsudo.monthValue
    })
  }

  protected async responseInitWebApi(response: ApiGeneralObjectArrayPayload): Promise<void> {
    if (_.isArray(response)) {
      this.koutsuhiList = response
    }
  }

  protected newKoutsuhi(): void {
    let path = '/koutsuhi/edit/'
    this.$router.push(path)
  }

  private async nextMonth() {
    this.$tcw.$store.basic.nextMonth()
    this.init()
  }
  private async prevMonth() {
    this.$tcw.$store.basic.prevMonth()
    this.init()
  }
  private async toThisMonth() {
    const getsudo = Getsudo.now(this.shimebi)
    this.$tcw.$store.basic.setTargetDate(getsudo.getDate())
    this.init()
  }
  private async selectMonth(getsudo: Getsudo) {
    const selectMonthDate = getsudo.getDate()
    this.$tcw.$store.basic.setTargetDate(selectMonthDate)
    this.init()
  }
}
